<template>
  <div class="c-shopping-grid__title">{{ category.title }}</div>
  <div class="c-shopping-grid">
    <slot></slot>
  </div>
</template>

<script>
import cmp from "./";

export default {
  name: "RasterCategory",
  ...cmp,
};
</script>
